import { Component, OnInit, Input, NgZone, Output, EventEmitter } from '@angular/core';
import { Installation } from '../../models/Installation';
import { GlobalMethodsService } from '../../services/global-methods.service';
import { GlobalVariablesService } from '../../services/global-variables.service';
import { StorageService } from '../../services/commons/storage.service';
import { PanelConfService } from '../../services/commons/panel-conf.service';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { Router } from '@angular/router';
import { AnalyticsService } from '../../services/commons/analytics.service';
import { ProfileInstallationService } from '../../services/commons/profile-installation.service';
import { AuthService } from '../../services/commons/auth.service';
import { ChatService } from '../../services/commons/chat.service';
import { ConfirmComponent } from '../modals/confirm/confirm.component';
import { ModalService } from 'src/app/services/commons/modal.service';
@Component({
  selector: 'app-searcher',
  templateUrl: './searcher.component.html',
  styleUrls: ['./searcher.component.scss'],
})
export class SearcherComponent implements OnInit {

  @Input('alarmActivated') alarmActivated: boolean;
  @Input('placeholderSelectInstallation') placeholderSelectInstallation: boolean;
  @Input('timerRunning') timerRunning: boolean;
  public installationsList: Installation[] = [];
  public installationName: string = '';
  public isntallationData: string = '';
  public userInstallation: string = '';
  public installationEvent: Subscription;
  public changeInstallationEvent: Subscription;
  public showOptions: boolean;
  public activateSearch: boolean;
  @Output()
  change: EventEmitter<{}> = new EventEmitter<{}>();

  constructor(public gms: GlobalMethodsService,
    private zone: NgZone,
    public gvs: GlobalVariablesService,
    private translate: TranslateConfigService,
    private storage: StorageService,
    private panelConfService: PanelConfService,
    public analytics: AnalyticsService,
    private authService: AuthService,
    private infInstallationService: ProfileInstallationService,
    private chatService: ChatService,
    private router: Router,
    private modalService: ModalService) {
    this.installationEvent = this.gms.installationListEvent().subscribe(async (installations: Installation[]) => {
      this.zone.run(async () => {
        await this.loadInstallationsList(installations);
      });
    });
    this.changeInstallationEvent = this.gms.changeInstallationEvent().subscribe(async (installation: Installation) => {
      this.zone.run(async () => {
        await this.toggleInstalationName(installation);
      });
    });
  }

  async ngOnInit() {
    this.gvs.user = await this.storage.getObject(this.gvs.AUTH_KEY);
    if (this.gvs.user != null) {
      this.installationsList = await this.storage.getObject(this.gvs.CONF_INSTALLATIONS + '_' + this.gvs.user.userName);
      await this.loadInstallationsList();
    }
  }

  ngOnDestroy() {
    if (this.installationEvent != null) {
      this.installationEvent.unsubscribe();
    }
    if (this.changeInstallationEvent != null) {
      this.changeInstallationEvent.unsubscribe();
    }
  }

  async loadInstallationsList(installations?: Installation[]) {
    if (installations != null && installations.length > 0) {
      this.installationsList = installations;
    }
    if (this.installationsList != null && this.installationsList.length > 0) {
      const installation: Installation = this.installationsList.find(x => x.selected === 1);
      if (installation != null) {
        this.installationName = installation.displayTitle;
        this.isntallationData = installation.ctr_no + ' ' + installation.street1;
        this.gvs.currentInstallation = installation;
        if (installations != null && installations.length > 0) {
          await this.gms.setInstallationEvent(installation);
        }
      } else {
        this.installationName = this.installationsList[0].displayTitle;
        this.isntallationData = this.installationsList[0].ctr_no + ' ' + this.installationsList[0].street1;
        this.gvs.currentInstallation = this.installationsList[0];
        if (installations != null && installations.length > 0) {
          await this.gms.setInstallationEvent(this.installationsList[0]);
        }
      }
    }
  }

  async showOpt() {
    this.showOptions = !this.showOptions;
  }

  async toggleInstalationName(installation) {
    this.gms.analyticsTrackEvent('searcher', { eventCategory: 'SICOR/Selector Instalacion', eventAction: 'Accion/Cambiar Instalacion Click' });
    await this.openCloseSearch();
    if (installation !== undefined && installation !== null) {
      const checkInternet = await this.gms.checkInternet();
      if (checkInternet) {
        if (!this.timerRunning) {
          if (!this.alarmActivated) {
            this.gms.showLoading = true;
            /*TO DO: Ocultar funcionalidad chat
            this.gms.clearCraChatStatusEvent();
            this.gms.clearSupChatStatusEvent();
            this.gvs.supportChatID = 0;
            this.gvs.craChatID = 0;*/
            this.gms.clearIntervalStatusInstallationEvent();
            this.showOptions = false;
            try {
              const response = await this.panelConfService.setLastIns(this.gvs.currentInstallation.s_ins, this.gvs.user.userName, installation.s_ins);
              if (response) {
                let credentials = await this.storage.getObject(this.gvs.AUTH_KEY);
                let result = await this.authService.updateToken(credentials, this.gvs.user.checkSession);
                if (result) {
                  let res = await this.panelConfService.setListInstallations(installation.s_ins, this.gvs.user.userName);
                  if (res.returnCode === 0){
                    const currentInstallation = this.installationsList.find(x => x.s_ins == installation.s_ins);
                    this.gvs.currentInstallation = currentInstallation;
                    await this.panelConfService.getInstallations(this.gvs.user.userName, this.gvs.lang);
                    await this.gms.setInstallationEvent(currentInstallation);
                    this.installationName = installation.displayTitle;
                    this.isntallationData = installation.ctr_no + ' ' + installation.street1;
                    this.installationsList.forEach(item => {
                      if (item.s_ins === installation.s_ins) {
                        item.selected = 1;
                      } else {
                        item.selected = 0;
                      }
                    });
                    await this.infInstallationService.checkIfUserIsMaster();
                    await this.analytics.setAnalyticsUserProperties(
                      this.gvs.isCurrentUserMaster ? 'MAESTRO' : 'OTRO',
                      this.gvs.currentInstallation.clientCategory,
                      this.gvs.currentInstallation.tariffCategory,
                      this.gvs.currentInstallation.tariffName,
                      this.gvs.currentInstallation.userid);
                      this.gms.showLoading = false;
                  } else {
                    this.gms.showLoading = false;
                  }
                  /*TO DO: Ocultar funcionalidad chat
                  await this.requestPendingMessages(4);
                  await this.requestPendingMessages(0);
                  this.chatService.appGetChat(this.gvs.user.userName, this.gvs.currentInstallation.s_ins, 0, 4, 1);
                  this.chatService.appGetChat(this.gvs.user.userName, this.gvs.currentInstallation.s_ins, 0, 0, 1);
                  this.gms.startChatStatusEvent();*/
                  if(this.router.url.includes('home')){
                    this.gms.startIntervalSatusInstallationEvent();
                  }
                }else{
                  /*TO DO: Ocultar funcionalidad chat
                  this.gms.startChatStatusEvent();*/
                  this.gms.startIntervalSatusInstallationEvent();
                }
              }else{
                /*TO DO: Ocultar funcionalidad chat
                this.gms.startChatStatusEvent();*/
                if(this.router.url.includes('home')){
                  this.gms.startIntervalSatusInstallationEvent();
                } 
              }
            } catch {
              /*TO DO: Ocultar funcionalidad chat
              this.gms.startChatStatusEvent();*/
              if(this.router.url.includes('home')){
                this.gms.startIntervalSatusInstallationEvent();
              }
            }
          }else{
            await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), await this.translate.getTranslate('MESSAGES.infoAlarmActivated'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
          }
        }else{
          const contentModal = await this.modalService.show(
            ConfirmComponent, "confirmModal",
            {
              modalTitle: await this.translate.getTranslate('MODAL.titleInfo'),
              modalSubtitle: await this.translate.getTranslate('MESSAGES.infoCyberSafeguardActivated'),
              paramMainButton: await this.translate.getTranslate('BUTTON.accept'),
              paramSecondButton: await this.translate.getTranslate('BUTTON.cancel'),
            },
            ['modal-icon']
          )

          contentModal.onDidDismiss().then(res => {
            this.zone.run(async () => {
              if (res.data != null && res.data.result != null && res.data.result) {
                await this.gms.clearIntervalStatusInstallationEvent();
                /*TO DO: Ocultar funcionalidad chat
                await this.gms.clearCraChatStatusEvent();
                await this.gms.clearSupChatStatusEvent();*/
                await this.gms.finishCountDownEvent(installation);
              }
            });
          });

          contentModal.present().then();
        }
      }
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async openCloseSearch() {
    this.activateSearch = !this.activateSearch;
    await this.change.emit({ 'activate': this.activateSearch, 'url': this.router.url });
  }

  async requestPendingMessages(chat_tp: number) {
    let chatOpen = false;
    if (chat_tp === 0) {
      chatOpen = this.gvs.craChatID != 0 ? true : false;
    } else if (chat_tp === 4) {
      chatOpen = this.gvs.supportChatID != 0 ? true : false;
    }
    if (chatOpen) {
      let newMessages = await this.chatService.appGetChat(this.gvs.user.userName, this.gvs.currentInstallation.s_ins, 0, chat_tp, 0);
      if (newMessages.length > 0) {
        if (chat_tp === 4) {
          this.gms.changeFooterChatNotif(newMessages.length);
        } else {
          this.gms.changeHeaderChatNotif(newMessages.length);
        }
      }
    }
  }
}
